<div
  class="c-notEnough"
  theming
  themingGroup="dailychallenge"
  themingAsset="notfunds-gems-background"
  [themingOverride]="event?.assets">
  <slotcom-wallet
    class="gems-wallet"
    [type]="'Gems'">
  </slotcom-wallet>

  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-notEnoughStart__container">
    <div class="c-notEnoughStart__info">
      <div class="c-notEnoughStart__text">
        <span class="text title"> {{ 'home.modals.no-enough.title.gems' | translate | uppercase }} </span>
        <span class="text subtitle">
          {{ 'home.modals.no-enough.subtitle.gems' | translate }} <br />
          {{ 'home.modals.no-enough.subtitle-2' | translate }}</span
        >
      </div>
    </div>

    <slotcom-button
      class="c-button--pink"
      (safeClick)="openShopGems()"
      audioType="payment">
      <span class="label">{{ 'home.modals.no-enough.get-more' | translate | uppercase }}</span>
    </slotcom-button>
  </div>
</div>
